module.exports = __webpack_public_path__ + "img/Weego.8307d59d.svg";